/**
 * @module stores/partnershipBadge
 * @description 고객사·협력사 신청 대기 건수 배지 Pinia 스토어 (SURINP-342 D12).
 * 주기 폴링을 하지 않는다 — 갱신 시점은 ① 메뉴 로드 직후 ② 신청 관리 화면 진입·재조회
 * ③ 승인·반려 처리 성공 직후 셋뿐이다. 실패는 삼킨다(배지가 안 뜰 뿐 메뉴는 살아 있어야 한다).
 */
import { defineStore } from 'pinia'
import { getPartnershipPendingCount } from '@/api/domain/partnershipInquiry'

/** 배지를 붙일 하위 메뉴 식별자 — stores/menu.js 의 정적 메뉴 정의와 같은 값 */
export const PARTNERSHIP_BADGE_MENU_CODE = 'PARTNERSHIP_INQUIRY_LIST'

// HeaderMenu(PC)와 MobileDrawer(모바일)가 동시에 호출할 때 API 중복 호출을 방지합니다.
let _fetchingPromise = null

export const usePartnershipBadgeStore = defineStore('partnershipBadge', {
  state: () => ({
    /** 검토 중 신청 건수. 0 이면 배지를 그리지 않는다. */
    count: 0
  }),
  actions: {
    /**
     * 대기 건수를 조회합니다. 진행 중인 호출이 있으면 그 Promise 를 공유합니다.
     * 실패하거나 응답이 기대 형태가 아니면 기존 값을 유지합니다 — 실패를 0 으로 단정하지 않습니다.
     *
     * @returns {Promise<void>}
     */
    async fetchCount() {
      if (_fetchingPromise) return _fetchingPromise
      _fetchingPromise = (async () => {
        try {
          const { status, data } = await getPartnershipPendingCount()
          const pendingCount = data && data.pendingCount
          if (status === 200 && typeof pendingCount === 'number') {
            this.count = pendingCount
          }
        } catch (e) {
          window.__APP_LOG__(e)
        } finally {
          _fetchingPromise = null
        }
      })()
      return _fetchingPromise
    },
    /**
     * 배지 상태를 초기화합니다. 로그아웃 시 호출합니다.
     */
    clearAll() {
      this.count = 0
      _fetchingPromise = null
    }
  }
})
